export const ROUTES = {
  home: '/',
  emails: '/emails',
  subscribers: '/subscribers',
} as const;
